'use strict';

const i18n = require('i18next');
const Mn = require('backbone.marionette');
const Template = require('system/ui/template/mode-indicator/diff.hbs');
const TimeHelper = require('common/ui/template/helper/time');

module.exports = Mn.View.extend({
    tagName: 'div',
    className: 'indicator-container',
    template: Template,
    templateContext: function() {
        const fromDt = this.getOption('fromDt');
        const toDt = this.getOption('toDt');

        return {
            from: (fromDt ? fromDt : i18n.t('title.diff.latest')),
            to: (toDt ? toDt : i18n.t('title.diff.latest'))
        }
    }
});



// WEBPACK FOOTER //
// ./system/ui/view/mode-indicator/diff.js